'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

var _slice = require('./slice');

var _slice2 = _interopRequireDefault(_slice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _prep2.default)({
    name: 'take',
    immutable: 'take',
    all: function all(amount) {
        return (0, _slice2.default)(0, amount);
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/take.js
// module id = 908
// module chunks = 35783957827783